export default {
  ANNUAL_INCOME_HEADER: "What is your annual income, before taxes?",
  RADIO_ITEMS: [
    {
      label: "< $20,000",
      value: {
        min: 0,
        max: 20000,
      },
    },
    {
      label: "$20,000 - $49,999",
      value: {
        min: 20000,
        max: 49999,
      },
    },
    {
      label: "$50,000 - $99,999",
      value: {
        min: 50000,
        max: 99999,
      },
    },
    {
      label: "$100,000 - $499,999",
      value: {
        min: 100000,
        max: 499999,
      },
    },
    {
      label: "$500,000 - $1,000,000",
      value: {
        min: 500000,
        max: 1000000,
      },
    },
    {
      label: "> $1,000,000",
      value: {
        min: 1000000,
        max: 1000000,
      },
    },
  ],
  ANNUAL_INCOME_BUTTON_HEADING: "Continue",
  SUBMIT_ERROR: "Enter a Valid Amount",
};
